import { transitionPersonalDetails } from "../../../actions/digiLifeLoanProtection/personalDetails";
import { setAddressProofDocumentsValue, setFormInvalid, setFormValid, setIdDocumentsValue, setIncomeProofDocumentsValue, setbankStatementDocumentsValue, setloanLetterDocumentsValue } from "../../../actions/digiLifeLoanProtection/uploadDocuments";
import { setUploadDocumentsValue, transitionUploadDocuments } from "../../../actions/kaMetlhaFuneralClaim/uploadDocuments";
import { FIELD_STATUS } from "../../../reducers/status";
import { getEmploymentType, getPersonalDetailsForm } from "../../../selectors/digiLifeLoanProtection/personalDetails";
import {  getDocumentsForm } from "../../../selectors/digiLifeLoanProtection/uploadDocuments";
import { getClaimentType } from "../../../selectors/kaMetlhaFuneralClaim/claimentDetails";
import { getDeceasedDetailsForm } from "../../../selectors/kaMetlhaFuneralClaim/deceasedDetails";
import { getUploadDocumentValidations } from "../../../selectors/kaMetlhaFuneralClaim/uploadDocuments";

const isUploadDocumentsValid = store => {
    const state = store.getState();
    const isValid = (field) => {
        return field && field.status === FIELD_STATUS.VALID;
    };
    const uploadDocumentsValidations=getUploadDocumentValidations(state)
    const claimentType=getClaimentType(state)
    const {cause, deceasedRelation} = getDeceasedDetailsForm(state)
    const {policeReport, childBirthCertificate, marriageAffidavit, marriageCertificate, affidavitSurname, affidavitRelation, ...remainingDocs} = uploadDocumentsValidations[claimentType?.displayValue]
    const formFields = {
        ...(['03','04'].includes(deceasedRelation?.value) ? {affidavitRelation} : []),
        ...(['03', '01'].includes(deceasedRelation?.value) ? {affidavitSurname} : []),
        ...(['01'].includes(deceasedRelation?.value) ? {marriageCertificate, marriageAffidavit} : []),
        ...(['02'].includes(deceasedRelation?.value) ? {childBirthCertificate} : []),
        ...(['02', '03'].includes(cause?.value) ? {policeReport} : []),
        ...remainingDocs,
    }



    const uploadDocumentsFields=[...Object.values(formFields)]
    const uploadDocumentsValid = uploadDocumentsFields.every(isValid)
    return uploadDocumentsValid 
}
export const uploadDocumentsRules = (store, next, action) => {
    const result = next(action);

    // Personal Information
    const isValid = isUploadDocumentsValid(store);
    store.dispatch(isValid ? transitionUploadDocuments.formValid() : transitionUploadDocuments.formInvalid());
  
    return result;
};

export const performUploadDocumentsValidation=(store)=>{

    const state=store.getState()
    const uploadDocumentsValidations=getUploadDocumentValidations(state)
    const claimentType=getClaimentType(state)
    const {cause, deceasedRelation} = getDeceasedDetailsForm(state)
    const {policeReport, childBirthCertificate, marriageAffidavit, marriageCertificate, affidavitSurname, affidavitRelation, ...remainingDocs} = uploadDocumentsValidations[claimentType?.displayValue]
    const formFields = {
        ...(['03','04'].includes(deceasedRelation?.value) ? {affidavitRelation} : []),
        ...(['03', '01'].includes(deceasedRelation?.value) ? {affidavitSurname} : []),
        ...(['01'].includes(deceasedRelation?.value) ? {marriageCertificate, marriageAffidavit} : []),
        ...(['02'].includes(deceasedRelation?.value) ? {childBirthCertificate} : []),
        ...(['02', '03'].includes(cause?.value) ? {policeReport} : []),
        ...remainingDocs,
    }
    Object.keys(formFields).map((property) => {
        const { fileName, fileContaint,file } = formFields[property];
        store.dispatch(setUploadDocumentsValue({ fileName, fileContaint, file, fieldType:property }));

    });
    

}

